<template>
    <div class="px-4 py-2">
        <h2>{{ pageTitle }}</h2>
        <b-row align-h="center">
            <b-col xl="9" cols="12">
                <prism-filters
                    :loading="loading"
                    @change="changeFilters"
                    @update="updateChart"
                />
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-3">
            <b-col xl="9" cols="12">
                <prism-chart ref="chart" :loading="loading" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import sleep from "@/utils/sleep";
import { Sources } from "@/modules/common/settings";
import api from "@/modules/common/api";
import PrismFilters from "./components/PrismFilters";
import PrismChart from "./components/PrismChart";

export default {
    name: "ViewPrisms",
    components: {
        PrismFilters,
        PrismChart
    },
    data() {
        return {
            needRequest: true,
            loading: false
        };
    },
    computed: {
        ...mapState("common", ["source"])
    },
    created() {
        this.results = [];
        this.simulationResults = [];
        this.reservoirInfos = [];
        this.pageTitle =
            this.source === Sources.JULHO_14 ? "Prismas Virtuais" : "Prismas";
    },
    methods: {
        changeFilters(field) {
            if (field !== "analysisVariable") {
                this.needRequest = true;
            }
        },
        async updateChart({
            pointIds,
            startDate,
            endDate,
            analysisVariable,
            requestedDataType
        }) {
            this.loading = true;

            await this.$nextTick(); // espera os filhos atualizarem

            await sleep(500);

            if (this.needRequest) {
                if (requestedDataType.measure) {
                    const { data } = await api.getResults(
                        this.source,
                        pointIds,
                        startDate,
                        endDate,
                        false
                    );
                    this.results = data;
                } else {
                    this.results = [];
                }

                if (requestedDataType.quota_flux) {
                    const { data } = await api.getReservoirInfos(
                        this.source,
                        startDate,
                        endDate
                    );
                    this.reservoirInfos = data;
                } else {
                    this.reservoirInfos = [];
                }

                if (requestedDataType.simulation) {
                    const { data } = await api.getResults(
                        this.source,
                        pointIds,
                        startDate,
                        endDate,
                        true
                    );
                    this.simulationResults = data;
                } else {
                    this.simulationResults = [];
                }

                this.needRequest = false;
            }

            this.$refs.chart.update({
                results: this.results,
                reservoirInfos: this.reservoirInfos,
                simulationResults: this.simulationResults,
                analysisVariable,
                requestedDataType
            });

            this.loading = false;
        }
    }
};
</script>
